export const FeaturedBadge = () => {
  return (
    <div 
      className="absolute top-2 left-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-md text-xs font-bold shadow-lg z-10"
      data-testid="featured-badge"
    >
      ⭐ FEATURED
    </div>
  );
};